module.exports = __webpack_public_path__ + "img/scratch.43116784.png";